import {get,post,url} from "../http"

class Header{
    //教师列表
    @url("nav/list")
    @get
    getnavlist(){}

}

export default new Header()